import { useEffect } from 'react';
import styled from 'styled-components';
import { useAuth0 } from '@auth0/auth0-react';
import { Box } from '@material-ui/core';
import { useRouter } from 'next/router';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Navigation from '../Navigation';
import theme from '../../utils/styles/theme';
import { useNavDrawer } from '../../hooks/useNavDrawer';
import { useStores } from '../../hooks/useStores';
import { Flex } from '../Flex';
import Sentry from '../SentryComponent';
import { Banner } from '../Banner';
import ErrorBoundary from '../ErrorBoundary';

const Container = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.blacks[0]};
  margin: 0;
  min-height: 100vh;
  padding: 0;
`;

const ContentContainer = styled.div`
  flex-grow: 1;
  max-width: 100%;
  min-height: 100vh;
  margin-left: 210px;
  position: relative;
  z-index: 1;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-left: 0;
  }
`;
const topLevelPageRegex = /\/?admin\/([^\/]+)\/?/;

const MainLayout = ({ children }) => {
  const permanentSidebar = useMediaQuery(`(min-width:${theme.breakpoints[2]})`);
  const { navOpen, closeNav } = useNavDrawer();
  const { storeInformation } = useStores();
  const { isAuthenticated } = useAuth0();
  const { pathname } = useRouter();

  let currentRoute = 'home';
  if (topLevelPageRegex.exec(pathname)) {
    [, currentRoute] = topLevelPageRegex.exec(pathname);
  }

  useEffect(() => {
    if (isAuthenticated) {
      storeInformation.getSubscriptionStatus();
      storeInformation.getGeneralInfo();
    }
  }, [isAuthenticated, storeInformation]);

  const handleButtonClick = () => {
    window.location.href = `${process.env.NEXT_PUBLIC_OLD_ADMIN_BASE_URI}/dashboard`;
  };

  return (
    <Container>
      <Sentry />
      {pathname !== '/login' && (
        <Navigation
          open={navOpen}
          variant={permanentSidebar ? 'permanent' : 'temporary'}
          onClose={closeNav}
          role="navigation"
          currentRoute={currentRoute}
        />
      )}
      <ContentContainer>
        <ErrorBoundary>
          {children}
          {storeInformation?.isTrialPlan && storeInformation.isTrialExpired && (
            <Box mx={4}>
              <Banner
                buttonText="START SELLING"
                onButtonClick={handleButtonClick}
                bannerText="Your trial has expired."
              />
            </Box>
          )}
        </ErrorBoundary>
      </ContentContainer>
    </Container>
  );
};

export default MainLayout;
